<template>
	<ja-radial-progress-bar
		:size="62"
		:value="financialHealthPct"
		:title="$t('financialHealth')"
		:status="$t(lifeStageData.studentSmileScoreData.message.toLowerCase())"
		role="img"
		:aria-label="ariaLabel"
	>
		<template v-slot:icon>
			<svgicon
				:aria-hidden="true"
				class="icon"
				:name="
					`financialStatus/${lifeStageData.studentSmileScoreData.message.toLowerCase()}`
				"
				:original="true"
			></svgicon>
		</template>
	</ja-radial-progress-bar>
</template>
<script>
import '../icons/financialStatus';
import FinancialHealth from '@/mixins/FinancialHealth';
import RadialProgressBar from '../ui/RadialProgressBar';

export default {
	components: {
		jaRadialProgressBar: RadialProgressBar
	},
	mixins: [FinancialHealth],
	props: {
		isLink: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		ariaLabel() {
			const labelArr = [
				this.$t('currentFinancialHealth', {
					status: this.$t(
						this.lifeStageData.studentSmileScoreData.message.toLowerCase()
					)
				})
			];
			if (this.isLink) {
				labelArr.push(this.$t('navigateToProfile'));
			}

			return labelArr.join(';');
		}
	}
};
</script>
<style lang="scss" scoped>
.icon {
	width: 40px;
	height: 40px;
}
</style>
